import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../config/firebase";


const getUserById = async (id) => {
    const docRef = doc(firestore, "users", id);
    const docSnap = await getDoc(docRef);

    if(docSnap.exists()){
        const userData = docSnap.data();
        userData["id"] = id;
        return userData;
    }else{
        console.log("No such document.")
    }
}

export default getUserById;